import { Table, ActionIcon, Menu, Text } from '@mantine/core';
import { IconDotsVertical, IconEdit, IconTrash } from '@tabler/icons-react';

import { CustomTable, CustomTableMobile, useResponsive } from '@/shared';
import { convertRemoteMethodsToTable } from '../utils/helpers/converter';

import type {
  TRemotePaymentMethod,
} from '../store/types';

type Props = {
  remoteMethods: TRemotePaymentMethod[];
  isLoading?: boolean;
  openEditModal: (item: TRemotePaymentMethod) => void;
  openDeleteModal: (item: TRemotePaymentMethod) => void;
};

export const RemoteMethodsTable = (props: Props) => {
  const {
    remoteMethods,
    isLoading,
    openEditModal,
    openDeleteModal,
  } = props;

  const { isDesktop } = useResponsive();

  const getActions = (item: TRemotePaymentMethod) => (
    <Menu position="bottom-end" shadow="md" width={200}>
      <Menu.Target>
        <ActionIcon variant="subtle">
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconEdit size={14} />}
          onClick={() => openEditModal(item)}
        >
          Редактировать
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          color="red"
          leftSection={<IconTrash size={14} />}
          onClick={() => openDeleteModal(item)}
        >
          Удалить
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );

  const titles = [
    'ID',
    'Название',
    'Валюта',
    'Создан',
    'Платёжная система',
    'Минимальное пополнение',
    'Максимальное пополение',
    'Данные',
  ];

  const rows = convertRemoteMethodsToTable(remoteMethods).map((item) => (
    <Table.Tr key={item.id}>
      <Table.Td>{item.id}</Table.Td>
      <Table.Td>{item.name}</Table.Td>
      <Table.Td>{item.currency}</Table.Td>
      <Table.Td>{item.created}</Table.Td>
      <Table.Td>{`${item.paymentSystemId} - ${item.paymentSystemName}`}</Table.Td>
      <Table.Td>{item.minRefill}</Table.Td>
      <Table.Td>{item.maxRefill}</Table.Td>
      <Table.Td>
        <p style={{ width: '200px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
          {item.data}
        </p>
      </Table.Td>
      <Table.Td width={50}>{getActions(item)}</Table.Td>
    </Table.Tr>
  ));

  const rowsMobile = convertRemoteMethodsToTable(remoteMethods).map((item) => ({
    key: item.id,
    headerActions: getActions(item),
    items: [
      { name: titles[1], value: item.name },
      { name: titles[2], value: item.currency },
      { name: titles[0], value: item.id },
      { name: titles[3], value: item.created },
      { name: titles[4], value: `${item.paymentSystemId} - ${item.paymentSystemName}` },
      { name: titles[5], value: item.minRefill },
      { name: titles[6], value: item.maxRefill },
      { name: titles[7], value: <Text truncate="end" size="xs">{item.data}</Text> },
    ],
  }));

  return isDesktop
    ? (
      <CustomTable
        titles={titles}
        rows={rows}
        isLoading={isLoading}
        isPaginated={false}
      />
    )
    : (
      <CustomTableMobile
        rows={rowsMobile}
        headerPointsCount={2}
        isPaginated={false}
        {...props}
      />
    );
};
